"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRawCapabilityConfigs = exports.capabilitySupportsConfig = void 0;
exports.isLegacyKproxyBuild = isLegacyKproxyBuild;
exports.transformConfigMetadataToOldFormat = exports.transformConfigMetadataDataType = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("./constants");
// These types are mostly placeholders and are not very accurate...

/**
 * Transform data type from json schema to the react component types
 */
const transformConfigMetadataDataType = argType => {
  switch (argType) {
    case 'boolean':
      return 'bool';
    case 'number':
      return 'float';
    case 'integer':
      return 'int';
    default:
      return argType;
    // Return as is if no mapping is found
  }
};

/**
 * Transforms the new API schema to the old constants format
 */
exports.transformConfigMetadataDataType = transformConfigMetadataDataType;
const transformConfigMetadataToOldFormat = metadata => {
  if (!metadata || !metadata.config) {
    return {};
  }
  const transformedConfig = {};
  metadata.config.forEach(arg => {
    const key = arg.name;

    // Determine the 'argument' field: env takes priority over arg
    const argumentValue = arg.env || arg.arg;

    // Determine the type - if options are provided, use 'select'
    const argType = arg.options && arg.options.length > 0 ? 'select' : transformConfigMetadataDataType(arg.type);
    transformedConfig[key] = {
      argument: argumentValue,
      label: arg.label || '',
      type: argType,
      description: arg.description,
      default: arg.default,
      sudoRequired: arg.sudoRequired || false,
      userControlled: arg.userControlled ?? false,
      cannotDelete: arg.cannotDelete || false,
      resetToDefault: arg.resetToDefault || false,
      minVersion: arg.minVersion,
      maxVersion: arg.maxVersion,
      rules: arg.rules || [],
      placeholder: arg.placeholder || '',
      autoInsertPrefix: arg.autoInsertPrefix || '',
      dependsOn: arg.dependsOn,
      required: arg.required || false,
      featureFlag: arg.featureFlag
    };

    // define data type as custom selector
    if (arg.customSelector) {
      transformedConfig[key].type = 'select';
      transformedConfig[key].showInputFilter = true;
      transformedConfig[key].customSelector = arg.customSelector;
      if (arg.customSelector === 'networkInterfaceSelect') {
        arg.specialString = interfaceVal => interfaceVal === 'any' ? 'All' : interfaceVal;
      }
    }
    if (arg.dependsOn) {
      transformedConfig[key].autoShowValue = arg.default ?? '';
    }

    // If options are provided, include them in the transformed config
    if (arg.options && arg.options.length > 0) {
      transformedConfig[key].options = arg.options;
    }
  });
  return transformedConfig;
};
exports.transformConfigMetadataToOldFormat = transformConfigMetadataToOldFormat;
const getRawCapabilityConfigs = capabilityKey => {
  switch (capabilityKey) {
    default:
      console.error(`No config found for capability key in getRawCapabilityConfigs: ${capabilityKey}`);
      // Return an empty object or throw an error based on your application's needs
      return {};
  }
};
exports.getRawCapabilityConfigs = getRawCapabilityConfigs;
const capabilitySupportsConfig = metadata => metadata !== null && metadata !== undefined && Array.isArray(metadata.config) && metadata.config.length > 0;

// A kproxy build is considered "legacy" once it is older than this.
exports.capabilitySupportsConfig = capabilitySupportsConfig;
const LEGACY_BUILD_AGE = {
  value: 1,
  unit: 'year'
};
function isLegacyKproxyBuild({
  agent_built_on,
  agent_version
}, now = _moment.default.utc()) {
  const cutoff = now.clone().subtract(LEGACY_BUILD_AGE.value, LEGACY_BUILD_AGE.unit);

  // Primary signal: the build date reported by the agent (e.g. "Mon, 30 Jun 2025").
  let builtOn = agent_built_on ? _moment.default.utc(agent_built_on, 'ddd, D MMM YYYY', true) : null;

  // Fallback: the known release date for this build when agent_built_on is missing/unparseable.
  if (!builtOn || !builtOn.isValid()) {
    const entry = agent_version ? _constants.KPROXY_VERSION_MAP[agent_version] : undefined;
    builtOn = entry ? _moment.default.utc(entry.builtOn) : null;
  }
  return !!builtOn && builtOn.isValid() && builtOn.isBefore(cutoff);
}